<template>
  <v-form>
    <v-row dense>
      <v-col cols="12" xs="12" md="3">
        <v-text-field name="transferAmount" dense outlined label="Amount" type="number" v-model="record.Amount"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="record.fromAccount"
          :items="accounts"
          label="From Account"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-autocomplete
          autocomplete="off"
          hide-details
          dense
          outlined
          v-model="record.toAccount"
          :items="accounts"
          label="To Account"
          item-text="Name"
          item-value="id"
        ></v-autocomplete>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
      </v-col>

      <v-col cols="12" xs="12" md="6">
        <v-text-field name="transferDesc" dense outlined label="Description" v-model="record.Desc"></v-text-field>
      </v-col>

      <v-col cols="12" md="12" xs="12" sm="12">
        <v-btn color="primary" @click="sendData" :loading="$store.state.btnLoader" :disabled="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  name: "AccountsIndex",
  props: {
    initial: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loader: false,
    record: {},
    accounts: [],
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.DocDate = date;
    },
    sendData() {
      if (
        this.record.Amount == undefined ||
        this.record.fromAccount == undefined ||
        this.record.toAccount == undefined
      ) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
      } else {
        this.$store.commit("btnLoader", true);

        var details = {
          amount: parseInt(this.record.Amount),
          from_account: parseInt(this.record.fromAccount),
          to_account: parseInt(this.record.toAccount),
          desc: this.record.Desc,
          date: this.record.DocDate,
        };

      this.$emit("data", details);
      }
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getAccounts();
  },
};
</script>